import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export class ResizeMapCommand extends Command {
    protected wamFile: WamFile;

    constructor(
        wamFile: WamFile,
        protected readonly width: number,
        protected readonly height: number,
        commandId?: string,
    ) {
        super(commandId);
        this.wamFile = wamFile;
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.mapWidth = this.width;
        overlay.mapHeight = this.height;
        return Promise.resolve();
    }
}
